import Fab from "@mui/material/Fab";
import React from "react";
import { withRouter } from "react-router";
import { Link } from "react-router-dom";
import IconView from "../IconView";
import { alpha } from "@mui/material/styles";

function FabView(props) {
  const {
    component,
    onClick,
    disabled = false,
    to,
    externalUrl,
    history,
    icon,
    size,
    arialabel,
    color = "primary",
    customFabBackgroundColor,
    customFabHoverColor = customFabBackgroundColor,
    style, // for overriding style
  } = props;

  const onClickAction = (() => {
    if (externalUrl || to) {
      return;
    } else {
      return onClick;
    }
  })();

  return (
    <Fab
      component={to ? Link : undefined}
      to={to}
      target={externalUrl ? "_blank" : undefined}
      rel={externalUrl ? "noopener" : undefined}
      href={externalUrl}
      size={size}
      aria-label={arialabel}
      style={{
        boxShadow:
          "0px 1px 3px 0px rgba(0, 0, 0, 0.2),0px 1px 1px 0px rgba(0, 0, 0, 0.14),0px 2px 1px -1px rgba(0, 0, 0, 0.12)",
        ...style,
      }}
      color={color}
      disabled={disabled}
      // variant={variant}
      onClick={onClickAction}
    >
      {icon && <IconView {...icon} />}
      {component}
    </Fab>
  );
}

const styles = {};

export default withRouter(FabView);
